import React, { type FC, type ReactElement } from "react";

import type {
    IIllustrationCustomSizeProps,
    IllustrationProps,
    IllustrationSizeProps,
} from "./types";

import classes from "./Illustration.styl";

const ILLUSTRATION_TEST_ID = "illustration-test-id";
const ILLUSTRATION_DISPLAY_NAME = "Illustration";

const isCustomSize = (
    props: IllustrationSizeProps,
): props is IIllustrationCustomSizeProps => {
    return props.size === "custom";
};

/**
 * Компонент для отображения и систематизации растровых иллюстраций. Регулирует размеры на стороне дизайна и разработки
 *
 * <a href="https://www.figma.com/design/vTg3KAvmAXA9LigeyiqCWL/%F0%9F%92%A0-Base-Components?m=auto&node-id=2369-85283&t=o9ZOyBV7UxhzDS1F-1" target="_blank">Спека</a>
 * @constructor
 */
export const Illustration: FC<IllustrationProps> = (props): ReactElement => {
    const { size = "112", src, srcSet, alt, "data-tsid": tsid } = props;

    const sizes = isCustomSize(props)
        ? { width: props.width, height: props.height }
        : { width: size, height: size };

    return (
        <img
            className={classes["illustration"]}
            src={src}
            srcSet={srcSet}
            alt={alt}
            data-tsid={tsid || ILLUSTRATION_TEST_ID}
            data-uikit={ILLUSTRATION_DISPLAY_NAME}
            {...sizes}
        />
    );
};

Illustration.displayName = ILLUSTRATION_DISPLAY_NAME;

export default Illustration;
